import React, { useEffect, useState } from "react";
import { ImageOverlay } from "react-leaflet";
import moment from "moment";
import { fetchTempLayer } from "../../api/apiRequests";
import { CACHE_DURATION } from "../../constants/constants";

const TemperatureLayer = ({ temperatureLayer }) => {
  const datetime = moment()
    .utc()
    .startOf("hour")
    .format("YYYY-MM-DDTHH:mm:ss[Z]");
  const cacheKey = `temperature_image_${datetime}`;

  const [imageUrl, setImageUrl] = useState(null);

  function blobToBase64(blob) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onerror = reject;
      reader.onload = () => {
        resolve(reader.result);
      };
      reader.readAsDataURL(blob);
    });
  }

  useEffect(() => {
    const cachedTime = localStorage.getItem(`${cacheKey}_time`);
    const cachedBase64 = localStorage.getItem(cacheKey);

    if (
      cachedBase64 &&
      cachedTime &&
      Date.now() - Number(cachedTime) < CACHE_DURATION
    ) {
      setImageUrl(cachedBase64);
      return;
    }

    fetchTempLayer(datetime)
      .then((blob) => blobToBase64(blob))
      .then((base64) => {
        setImageUrl(base64);
        localStorage.setItem(cacheKey, base64);
        localStorage.setItem(`${cacheKey}_time`, Date.now().toString());
      });
  }, [datetime]);

  if (!imageUrl || !temperatureLayer) return null;

  return (
    <ImageOverlay
      opacity={0.5}
      url={imageUrl}
      bounds={[
        [-30, -140],
        [64.1, -29.8],
      ]}
    />
  );
};

export default TemperatureLayer;
